import { useTranslation } from 'react-i18next';
import { useBodyClass } from '@/hooks/useBodyClass';
import { useThesaurusTerm, useInforme } from '@/hooks/api/useThesaurus';
import Link from '@/components/LangLink/LangLink';
import Layout from '@/components/Layout/Layout';
import arrowRight from '@/assets/media/img/ico-fletxa-dreta.svg';
import downloadIcon from '@/assets/media/img/ico-descarrega.svg';
import Loading from '@/components/Loading/Loading';
import { getImageUrl } from '@/utils/dedaloUtils';

function Home() {
    const { t } = useTranslation();
    useBodyClass('home');
    const { data, isLoading, error } = useThesaurusTerm('15,17,22');
    const { data: informeData, isLoading: informeLoading, error: informeError } = useInforme();
    const { data: represaliadasData, isLoading: represaliadasLoading, error: represaliadasError } = useThesaurusTerm('53');

    const uri = represaliadasData ? represaliadasData?.[0]?.uri : null;
    const represaliadasLink = JSON.parse(uri)?.[0]?.iri || null;
    const informeUri = informeData ? informeData?.[0]?.pdf_resolved : null;
    const informeLink = informeUri ? JSON.parse(informeUri)?.[0] : null;

    if (isLoading || informeLoading || represaliadasLoading) return <Layout><Loading /></Layout>
    if (error || informeError || represaliadasError) return <Layout><Loading error={true}/></Layout>

    return (
        <Layout page="home">
            <div className="wrapper">
                <div className="columns is-widescreen links-home link-dn is-uppercase has-text-white gap-8">
                    {data.map((el) => {
                        const termArray = el.term.split(':');
                        const title = termArray[0] ? termArray[0].trim() : '';
                        const description = termArray[1] ? termArray[1].trim() : '';

                        return (
                            <div key={el.term_id} className="column">
                                <div className="flow--2xs full-link">
                                    <h2 className="is-family-secondary fluid-24-28">
                                        <Link to={'/' + el.web_path} className="has-text-light">
                                            {title}
                                        </Link>
                                    </h2>
                                    <p className="is-size-3">{description}</p>
                                    <img src={arrowRight} alt="" />

                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="wrapper is-hidden-mobile">
                <div className="mt-8 has-text-white is-flex is-justify-content-space-between">
                    <div className="link-dn full-link">
                        <h2 className="is-family-secondary fluid-24-28 is-uppercase">
                            <a href={getImageUrl(informeLink)} className="has-text-light" target="_blank">
                                {informeData[0].term}
                            </a>
                        </h2>
                        <div className="is-flex is-align-items-center gap-2">
                            <p className="is-size-3 link-dn">{t('Descarga') + ' ' + informeData[0].term.toLowerCase()}</p>
                            <img src={downloadIcon} alt="" />
                        </div>
                    </div>
                    <div>
                        <h2 className="is-family-secondary fluid-24-28 is-uppercase">
                            <a href={represaliadasLink} target="_blank" className="has-text-light link-dn">
                                {represaliadasData[0].term}
                            </a>
                        </h2>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Home;
